import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Switch,
  Tooltip,
  Typography,
} from "@mui/material";
import { RouteType } from "../../Routes/Routesconfig";
import { Link, useLocation } from "react-router-dom";
import {
  MasterDataContextType,
  useMasterData,
} from "../../ContextAPI/MasterContext";
import { useCallback, useEffect } from "react";
import SVG from "../../Assests/SVG";
import { useTranslation } from "react-i18next";

const SidebarItem = ({ item }: { item: RouteType }) => {
  let location = useLocation();
  const { t } = useTranslation();
  const { masterState, dispatchMaster } = useMasterData();

  const handleInputChange = useCallback(
    (field: keyof MasterDataContextType, value: boolean | string) => {
      dispatchMaster({ type: "SET_FIELD", field, value });
    },
    [dispatchMaster]
  );

  useEffect(() => {
    handleInputChange("currentSideBarLocation", location.pathname);
  }, [location]);

  const displayText = t(item?.sidebarProps?.displayText ?? "");

  return item.sidebarProps && item.path && !item.path.includes("subscribe") ? (
    <ListItemButton
      component={item.disabled ? "div" : Link}
      to={item.disabled ? "#" : item.path}
      // onClick={() => {
      //   handleInputChange("sidebaropen", !masterState.sidebaropen);
      // }} // Avoid navigation if disabled
      sx={{
        pointerEvents: item.disabled ? "none" : "auto", // Disable pointer events if disabled
        "&: hover": {
          backgroundColor: "#3D5476",
        },
        backgroundColor:
          masterState.currentSideBarLocation == item.path ? "#3D5476" : `none`,

        paddingY: "2px",
        //paddingX: "24px",
        //borderRadius: `25px`
      }}
      style={{ color: "#FFFFFF" }}
    >
      {/* <Tooltip title={t(item?.sidebarProps?.displayText ?? "")}>
        <ListItemIcon
          sx={{
            color: "#fff",
            margin: `-21px`,
            marginLeft: "5px",
          }}
        >
          {item.sidebarProps.icon && item.sidebarProps.icon}
        </ListItemIcon>
      </Tooltip> */}
      <ListItemText
        sx={{ marginLeft: "22px" }}
        disableTypography
        primary={
          <Typography
            variant="subtitle2"
            style={{ color: item.disabled ? "#d3d3d3" : "#FFFFFF" }}
          >
            {t(item?.sidebarProps?.displayText ?? "")}
          </Typography>
        }
      />
    </ListItemButton>
  ) : item?.path?.includes("subscribe") ? (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-end",
      }}
    >
      <div style={{ width: "45%" }}>
        <Typography
          variant="subtitle2"
          style={{
            color: item.disabled ? "#d3d3d3" : "#FFFFFF",
            textAlign: "left",
          }}
        >
          {t(item?.sidebarProps?.displayText ?? "")}
        </Typography>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-end",
          marginLeft: "10%",
          width: "30%",
        }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <SVG.InfoIcon />
        </div>

        <Switch
          checked={!item.disabled} // If item is not disabled, the switch will be on
          disabled={item.disabled}
        />
      </div>
    </div>
  ) : null;
};
export default SidebarItem;
